import { render, staticRenderFns } from "./ProcessClosedButton.vue?vue&type=template&id=95e4aa4e"
import script from "./ProcessClosedButton.vue?vue&type=script&lang=js"
export * from "./ProcessClosedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports